import { InputValidationRule } from '../Input';
import { ValidationError } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/ValidatorError';
import { VARIABLE_VALIDATION_REGEX } from './Validator';
export class InputValidator {
    validate(model) {
        if (model.validation) {
            if (!model.validation.rule) {
                throw new ValidationError('The validation rule is required');
            }
            if (!model.validation.error || model.validation.error == '') {
                throw new ValidationError('The validation error message is required');
            }
            if (model.validation.rule == InputValidationRule.Regex &&
                !model.validation.regex) {
                throw new ValidationError("The regular expression should be provided when using the 'regex' validation rule");
            }
            if (model.validation.rule == InputValidationRule.Type &&
                !model.validation.type) {
                throw new ValidationError("The media type should be provided when using the 'type' validation rule");
            }
        }
        if (model.variable !== undefined) {
            if (!model.variable.match(VARIABLE_VALIDATION_REGEX)) {
                throw new ValidationError('The input variable name should be composed only by letters, numbers and dots');
            }
            if (model.variable.length === 0) {
                throw new ValidationError('The input variable name is empty');
            }
            if (model.variable.length > 50) {
                throw new ValidationError('The input variable name has more than 50 characters');
            }
        }
        if (model.expiration !== undefined) {
            if (model.expiration.length === 0) {
                throw new ValidationError('The input variable name is empty');
            }
            else {
                const hourFormatArray = model.expiration.split(':');
                const expirationTime = (Number(hourFormatArray[0]) * 60) + Number(hourFormatArray[1]);
                if (isNaN(Number(expirationTime))) {
                    throw new ValidationError('The input variable is not a number');
                }
                if (expirationTime % 1 !== 0) {
                    throw new ValidationError('The time limit is decimal');
                }
                if (expirationTime < 1) {
                    throw new ValidationError('The time limit is lower than 1');
                }
                if (expirationTime > 1380) {
                    throw new ValidationError('The time limit is higher than 1380');
                }
            }
        }
    }
}
